import { createFeatureSelector } from '@ngrx/store';
import { IExportState } from './export.reducer';
import { exportFeatureKey, FileModel } from './types';
import { createApiCallSelectors } from '../../../common/store/generic.selectors';

const exportFeatureState =
  createFeatureSelector<IExportState>(exportFeatureKey);

export const exportSelectors = {
  exportToCsv: createApiCallSelectors<FileModel, IExportState>(
    exportFeatureState,
    'exportToCsv',
  ),
};
